import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import logo from "../assets/krs-logo-transparent.png";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("krs_token", res.data.token);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={logo} alt="KRS" className="h-24 w-auto mx-auto mb-4" />
          <p className="font-sans text-[11px] tracking-[0.22em] uppercase text-gold">Admin CRM</p>
        </div>
        <form onSubmit={submit} className="bg-cream p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={20} className="text-gold" strokeWidth={1.5} />
            <h1 className="font-serif text-2xl text-navy">Sign In</h1>
          </div>
          {error && <div className="mb-5 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 font-sans">{error}</div>}
          <label className="font-sans text-[11px] tracking-wide-nav uppercase text-charcoal/60 mb-2 block">Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-navy/25 py-3 mb-6 font-sans text-navy focus:border-gold focus:outline-none transition-colors" placeholder="you@email.com" autoComplete="username" />
          <label className="font-sans text-[11px] tracking-wide-nav uppercase text-charcoal/60 mb-2 block">Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-navy/25 py-3 mb-8 font-sans text-navy focus:border-gold focus:outline-none transition-colors" placeholder="••••••••" autoComplete="current-password" />
          <button type="submit" disabled={loading} className="w-full bg-navy text-cream py-4 font-sans text-[12px] tracking-wide-nav uppercase hover:bg-gold hover:text-navy transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
